



















































































import Vue from 'vue';
import store from '@/store';

import {
  GettingStartedPeerGroup,
  BasePeerGroup,
  BaseOrganization
} from '@/models';
import { WorkflowStep } from '@/store/getStarted';
import * as InputValidation from '@/mixins/inputValidation';

import GetStartedNav from '@/components/getStarted/GetStartedNav.vue';

interface ExistingOrg extends BaseOrganization {
  peerGroups: BasePeerGroup[];
}

export default Vue.extend({
  components: {
    GetStartedNav
  },

  data: () => {
    return {
      communityUrl: process.env.VUE_APP_UNRULR_ON_THE_WEB_URL
    };
  },

  computed: {
    name(): string {
      return store.state.getStarted.orgName;
    },

    nameValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.name, 250, true);
    },

    peerGroups(): GettingStartedPeerGroup[] {
      return store.state.getStarted.existingPeerGroups;
    },

    canCreateNewOrg(): boolean {
      return this.nameValidation.valid;
    },

    orgs(): ExistingOrg[] {
      const orgMap = this.peerGroups.reduce(
        (acc: { [key: number]: ExistingOrg }, group) => {
          const org = acc[group.organization.organizationId] || {
            ...group.organization,
            peerGroups: []
          };

          const updatedOrg = { ...org, peerGroups: [...org.peerGroups, group] };

          const updatedAcc = {
            ...acc,
            [group.organization.organizationId]: updatedOrg
          };

          return updatedAcc;
        },
        {}
      );

      return Object.values(orgMap);
    },

    hasOrgs(): boolean {
      return this.orgs.length > 0;
    },

    scholarship(): boolean {
      return store.state.getStarted.accountType.toLowerCase() === 'scholarship';
    }
  },

  methods: {
    goToOrg(organizationId: number) {
      this.$router.push({
        name: 'Organization',
        params: {
          organizationId: `${organizationId}`
        }
      });
    },

    updateName(name: string) {
      store.dispatch.getStarted.setOrgName(name);
    },

    next() {
      store.dispatch.getStarted.goToStep(
        WorkflowStep.CHOOSE_GOOGLE_CLASSROOM_OR_MANUAL
      );
    }
  }
});
